// umbralesVITA.js
// ─────────────────────────────────────────────────────────────
// TABLA ÚNICA DE UMBRALES DE ESTADO TERRITORIAL — VITA v1
// ─────────────────────────────────────────────────────────────
// Única fuente de verdad de los cortes de IVT.
// La consultan buildTerritorialState, buildPredictiveEngine
// y useCognitiveAlerts, para que NUNCA se contradigan.
//
// Postura: VITA es PREVENTIVO. Cortes sensibles (avisan temprano).
// Versión 1 = hipótesis experta, sujeta a validación con datos
// reales (snapshots). Master Core: nunca fingir omnisciencia.
//
// Cortes oficiales por IVT:
//   Estable                   0–19
//   Observación              20–34
//   Sensibilidad Creciente   35–49
//   Activación Territorial   50–64
//   Convergencia Narrativa   65–79
//   Escalamiento Territorial 80–100
// ─────────────────────────────────────────────────────────────

export const UMBRALES_IVT = {
  ESCALAMIENTO: 80,
  CONVERGENCIA: 65,
  ACTIVACION: 50,
  SENSIBILIDAD: 35,
  OBSERVACION: 20
};

// Metadatos visuales por estado (color + severidad).
// Centralizados para que todos los módulos usen lo mismo.
export const ESTADOS_META = {
  'Escalamiento Territorial': { color: '#ef4444', severity: 'Crítica' },
  'Convergencia Narrativa':   { color: '#f97316', severity: 'Alta' },
  'Activación Territorial':   { color: '#eab308', severity: 'Media-Alta' },
  'Sensibilidad Creciente':   { color: '#22c55e', severity: 'Media' },
  'Observación':              { color: '#06b6d4', severity: 'Baja' },
  'Estable':                  { color: '#64748b', severity: 'Baja' }
};

// Jerarquía de severidad (para comparar cuál estado es "peor").
// Única tabla de severidad del sistema.
export const ESTADO_SEVERIDAD = {
  'Escalamiento Territorial': 6,
  'Convergencia Narrativa': 5,
  'Activación Territorial': 4,
  'Sensibilidad Creciente': 3,
  'Observación': 2,
  'Estable': 0
};

// Devuelve SOLO el nombre del estado a partir del IVT.
// Función base que comparten todos los motores.
export function estadoDesdeIVT(ivt = 0) {
  if (ivt >= UMBRALES_IVT.ESCALAMIENTO) return 'Escalamiento Territorial';
  if (ivt >= UMBRALES_IVT.CONVERGENCIA)  return 'Convergencia Narrativa';
  if (ivt >= UMBRALES_IVT.ACTIVACION)    return 'Activación Territorial';
  if (ivt >= UMBRALES_IVT.SENSIBILIDAD)  return 'Sensibilidad Creciente';
  if (ivt >= UMBRALES_IVT.OBSERVACION)   return 'Observación';
  return 'Estable';
}

// Devuelve el estado completo (nombre + color + severidad) desde el IVT.
export function estadoCompletoDesdeIVT(ivt = 0) {
  const state = estadoDesdeIVT(ivt);
  const meta = ESTADOS_META[state] || ESTADOS_META['Estable'];
  return { state, color: meta.color, severity: meta.severity };
}